/* Standard Shopify search stays usable as a native GET form. */
(() => {
  'use strict';
  const TF = window.Nbloop;
  if (!TF || TF.search) return;
  TF.search = true;
  document.addEventListener('submit', event => {
    if (!event.target.matches('.nl-search-form')) return;
    const field=event.target.querySelector('[name=q]');
    if (!field) return;
    field.value=field.value.trim();
    if (!field.value) { event.preventDefault(); field.focus(); }
  });
})();
